import { ModalDialog } from 'components/ModalDialog/ModalDialog'
import { Button } from 'components/Button'
import Styles from './ConfirmDialog.module.scss'

interface Props {
  doc: string
  onClose: () => void
  onConfirm: () => void
}

export const ConfirmPublishingDialog = ({ doc, onClose, onConfirm }: Props) => {
  return (
    <ModalDialog
      title={`Confirm publishing this document?`}
      onClose={onClose}
      footer={
        <div className={Styles.footer}>
          <Button size="md" variant="tertiary" onPress={onClose}>
            Cancel
          </Button>
          <Button className={Styles.confirmButton} size="md" onPress={onConfirm}>
            Add document
          </Button>
        </div>
      }
    >
      <div className={Styles.body}>
        <p>This folder is shared publicly, the added document will be shared publicly as well.</p>

        <ul>
          <li className={Styles.messages}>{doc}</li>
        </ul>
      </div>
    </ModalDialog>
  )
}
